import type { RefObject } from 'react'

import { useEffect, useState } from 'react'

/**
 * Tracks an element's rendered width. Starts from `fallback` so server and first client render agree.
 */
export const useElementWidth = (ref: RefObject<HTMLElement | null>, fallback: number): number => {
    const [width, setWidth] = useState(fallback)

    useEffect(() => {
        const element = ref.current

        if (!element) return

        const update = (): void => {
            const next = Math.round(element.getBoundingClientRect().width)

            if (next > 0) setWidth(next)
        }

        update()

        const observer = new ResizeObserver(update)

        observer.observe(element)

        return () => observer.disconnect()
    }, [ref])

    return width
}
